import element from "./element.js";
export const updateElement = element.update;
export default {
    updateElement
};
